export default __webpack_public_path__ + "static/media/logo-xl-768w.e910901d.webp";